import { render, staticRenderFns } from "./BlackListImport.vue?vue&type=template&id=2afda2c9&"
import script from "./BlackListImport.vue?vue&type=script&lang=js&"
export * from "./BlackListImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports